// constants/emailConstants.js

export const EMAIL_TEMPLATE_TYPES = {
    ORDER_CONFIRMATION: 'order_confirmation',
    ORDER_READY: 'order_ready',
    ORDER_CANCELLED: 'order_cancelled',
    ORDER_DELIVERED: 'order_delivered',
    USER_REGISTRATION: 'user_registration',
    USER_WELCOME: 'user_welcome',
    PASSWORD_RESET: 'password_reset',
    EMAIL_VERIFICATION: 'email_verification',
    LOYALTY_POINTS_EARNED: 'loyalty_points_earned',
    LOYALTY_POINTS_REDEEMED: 'loyalty_points_redeemed',
    MERCHANT_REGISTRATION: 'merchant_registration',
    MERCHANT_APPROVAL: 'merchant_approval',
    MERCHANT_REJECTION: 'merchant_rejection',
    PROMOTIONAL: 'promotional',
    NEWSLETTER: 'newsletter',
    ACCOUNT_SUSPENSION: 'account_suspension',
    ACCOUNT_REACTIVATION: 'account_reactivation',
};

export const EMAIL_TEMPLATE_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    DRAFT: 'draft',
};

// Default template types with labels (fallback if API fails)
export const DEFAULT_TEMPLATE_TYPES = [
    { type: 'order_confirmation', label: 'Order Confirmation' },
    { type: 'order_ready', label: 'Order Ready' },
    { type: 'order_cancelled', label: 'Order Cancelled' },
    { type: 'order_delivered', label: 'Order Delivered' },
    { type: 'user_registration', label: 'User Registration' },
    { type: 'user_welcome', label: 'User Welcome' },
    { type: 'password_reset', label: 'Password Reset' },
    { type: 'email_verification', label: 'Email Verification' },
    { type: 'loyalty_points_earned', label: 'Loyalty Points Earned' },
    { type: 'loyalty_points_redeemed', label: 'Loyalty Points Redeemed' },
    { type: 'merchant_registration', label: 'Merchant Registration' },
    { type: 'merchant_approval', label: 'Merchant Approval' },
    { type: 'merchant_rejection', label: 'Merchant Rejection' },
    { type: 'promotional', label: 'Promotional' },
    { type: 'newsletter', label: 'Newsletter' },
    { type: 'account_suspension', label: 'Account Suspension' },
    { type: 'account_reactivation', label: 'Account Reactivation' },
];

export const formatTemplateType = (type) => {
    return type
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

// Enhanced function to get template type label from API data or fallback
export const getTemplateTypeLabel = (type, templateTypes = []) => {
    const apiType = templateTypes.find(t => t.type === type);
    if (apiType) {
        return apiType.label;
    }
    
    // Fallback to default formatting
    return formatTemplateType(type);
};

export const getStatusColor = (status) => {
    switch (status) {
        case EMAIL_TEMPLATE_STATUS.ACTIVE:
            return 'green';
        case EMAIL_TEMPLATE_STATUS.INACTIVE:
            return 'red';
        case EMAIL_TEMPLATE_STATUS.DRAFT:
            return 'yellow';
        default:
            return 'gray';
    }
};

// Helper function to get template types with fallback
export const getTemplateTypesWithFallback = (apiTypes = []) => {
    if (apiTypes && apiTypes.length > 0) {
        return apiTypes;
    }
    return DEFAULT_TEMPLATE_TYPES;
};
